import {defineStore} from "pinia";
import {ref} from "vue";
import axios from "axios";

export const usePriceStore = defineStore('prices', () => {
    const prices = ref({});
    const loadPricesFromApi = async (ids, customerId) => {
        const {data} = await axios.post(`https://www.motonet.cz/eq-api/1/prices/${customerId}`,
            {id_goods: ids},
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                withCredentials: false
            }
        );
        prices.value = Object.assign({}, prices.value, data.data);
        return prices.value;
    }

    const forgetPrices = () => {
        prices.value = {};
    }

    return {prices, loadPricesFromApi, forgetPrices}
})
